// extracted by mini-css-extract-plugin
export var pillWrapper = "_r7-0";
export var showOverflow = "_r7-1";